import { Loader, NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCreateDocumentImporterTemplate } from 'src/hooks/document-importer-template/create-document-importer-template.hook';
import { useUpdateDocumentImporterTemplate } from 'src/hooks/document-importer-template/update-document-importer-template.hook';
import { useGetDocumentImporterTemplate } from 'src/hooks/document-importer-template/get-document-importer-template-by-id.hook';

import { DocumentImportPatternForm } from './components/document-import-pattern-form';
import { IDocumentImportPatternValues } from './change-document-import-pattern.interfaces';

const ChangeDocumentImportPattern = ({ id, onClose }: { id?: string; onClose: () => void }) => {
  const { documentImporterTemplate, loading } = useGetDocumentImporterTemplate(id);
  const {
    createDocumentImporterTemplate,
    loading: createLoading,
  } = useCreateDocumentImporterTemplate({
    onSuccess: onClose,
  });
  const {
    updateDocumentImporterTemplate,
    loading: updateLoading,
  } = useUpdateDocumentImporterTemplate({
    onSuccess: onClose,
  });

  const currentCompanyId = useGetCurrentCompanyId();

  const { _id, title, separator, valueEmployeeId } = documentImporterTemplate || {};

  const handler = _id ? updateDocumentImporterTemplate : createDocumentImporterTemplate;
  const loader = _id ? updateLoading : createLoading;

  const isEdit = documentImporterTemplate?._id;

  const initialValue = isEdit
    ? {
        title,
        separator,
        valueEmployeeId,
      }
    : ({} as IDocumentImportPatternValues);

  const onFinish = (values: any) => {
    const { templateFileId, valueEmployeeId, ...rest } = values;

    if (templateFileId && templateFileId?.file.status === 'removed') {
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: 'File not selected',
      });
    }

    handler({
      variables: {
        payload: {
          ...(_id && { _id }),
          ...rest,
          companyId: currentCompanyId,
          valueEmployeeId: Number(valueEmployeeId)
        },
      },
    });
  };

  if (loading) return <Loader />;

  return (
    <DocumentImportPatternForm
      initialValues={initialValue}
      onClose={onClose}
      loading={loader}
      onFinishHandler={onFinish}
    />
  );
};

export default ChangeDocumentImportPattern;
